import { render } from "./FacebookFormInput.vue?vue&type=template&id=e6d90e00&scoped=true&ts=true"
import script from "./FacebookFormInput.vue?vue&type=script&lang=ts"
export * from "./FacebookFormInput.vue?vue&type=script&lang=ts"

import "./FacebookFormInput.vue?vue&type=style&index=0&id=e6d90e00&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d90e00"]])

export default __exports__